<template>
    <ul class="switch-tab-wrapper">
        <li
            class="picker-item"
            v-for="(pick, index) in pickDatas"
            :key="index"
            @click="itemSelect(pick, index)"
            :class="{ on: index === currentIdx }"
        >
            {{ pick.label }}
        </li>
    </ul>
</template>

<script>
export default {
    name: "SwitchTabs",
    props: ["pickDatas", "current"],
    data() {
        return {
            currentIdx: this.current
        };
    },
    watch: {
        current() {
            this.currentIdx = this.current;
        }
    },
    methods: {
        itemSelect(pickItem, idx) {
            if (idx === this.currentIdx) {
                return;
            }

            this.currentIdx = idx;
            this.$emit("switch", pickItem);
        }
    }
};
</script>

<style lang="scss" scoped>
.switch-tab-wrapper {
    background: #ffffff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    font-size: 0;
    padding: 0;
    margin-right: 16px;
    box-sizing: border-box;

    .picker-item {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        min-width: 80px;
        font-size: 12px;
        text-align: center;
        border-right: 1px solid #d9e4ef;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
            color: #2ec2ff;
        }
        &.on {
            background: #2ec2ff;
            border-color: #2ec2ff;
            color: #fff;
        }
        &:first-child {
            border-radius: 4px 0 0 4px;
        }
        &:last-child {
            border-right: none;
            border-radius: 0px 4px 4px 0px;
        }
    }
}
</style>
